import { forwardRef, memo, ReactNode, Ref } from 'react';
import { StyledButton as BaseStyledButton } from 'shared/button/Button';
import styled from 'styled-components';

const StyledButton = styled(BaseStyledButton)`
    align-items: center;
`;

export type QuickFilterToggleProps = Readonly<{
    id: string;
    /**
     * Title to apply to the toggle button
     * Also used as the ARIA label
     */
    title?: string;
    /**
     * Content to render in the toggle button
     */
    children: ReactNode;
    /**
     * Whether the quick filter is toggled on or not
     */
    isToggled: boolean;
    /**
     * Callback to toggle quick filter
     */
    onToggle: () => void;
    className?: string;
    disabled?: boolean;
}> &
    Pick<React.HTMLAttributes<HTMLButtonElement>, 'onBlur'>;

function QuickFilterToggle(
    {
        id,
        title,
        children,
        isToggled,
        onToggle,
        className,
        disabled,
    }: QuickFilterToggleProps,
    ref: Ref<HTMLButtonElement>
) {
    return (
        <StyledButton
            id={id}
            appearance={isToggled ? 'primary' : 'subtle'}
            spacing="compact"
            title={title}
            ariaLabel={title}
            onClick={onToggle}
            ref={ref}
            className={className}
            disabled={disabled}
            // TODO @jp: Why... the hell... does this not expose onBlur?
            // onBlur={onBlur}
        >
            {children}
        </StyledButton>
    );
}

const memoQuickFilterToggle = memo(forwardRef(QuickFilterToggle));
export { memoQuickFilterToggle as QuickFilterToggle };
